import React from "react";

const AboutSection = () => {
  return (
    <div className="w-[960px]">
      <h2 className="mt-6 mb-6 text-2xl">About</h2>
      <p>
        I am directly trying to compete with Elon's X. So it would be somewhat
        helpful if you gave this one man team social network a chance.
        Foundation was built in like 4-5 days. The backend with frontend and
        basic authentication.
      </p>
      <p>
        There will never be ads, cookie popups, gdpr bullshit, and I will never
        sell your data. Yes, you have to trust me with that. I am based
        christian schizo lifter, arch enthusiast, and for sure if I say I will
        not sell your data, I will not sell your data.
      </p>
      <p>
        Only cucks sell data. If you want to donate,{" "}
        <a href="mailto:28@danielradosa.com">contact me</a>, feel free to do so.
        However, I will never ask you for your or yours mom money.
      </p>
    </div>
  );
};

export default AboutSection;
